import { InspectionTab, InspectionType } from '@/utilities/constants';

export const mapToChecksAdminInspectionType = (inspectionType: InspectionType): InspectionType => {
  switch (inspectionType) {
    case InspectionType.WORKFACE_AREA_INSPECTION:
    case InspectionType.AREA_CHECK:
    case InspectionType.CORY_AREA_CHECK:
      return InspectionType.WORKFACE_AREA_INSPECTION;
    case InspectionType.CUTTING_PERMIT:
    case InspectionType.REHAB_CUTTING_PERMIT:
      return InspectionType.CUTTING_PERMIT;
    case InspectionType.CUSTOM_EQUIPMENT:
    case InspectionType.PRE_OP:
    case InspectionType.EQUIPMENT_CHECK:
    case InspectionType.BORER_FLEXIVEYOR_PREOP_CHECK:
    case InspectionType.BORER_CUTTING_CHECK:
    case InspectionType.POST_CUTTING_CHECK:
    case InspectionType.MINER_PRE_OP:
    case InspectionType.MINER_RUNNING:
    case InspectionType.BRIDGES_RUNNING:
    case InspectionType.BRIDGES_PRE_OP:
    case InspectionType.BORER_INSPECTION:
    case InspectionType.MINEVEYOR_INSPECTION:
    case InspectionType.CORY_EQUIPMENT_CHECK:
      return InspectionType.CUSTOM_EQUIPMENT;
    case InspectionType.CUSTOM_AREA_CHECK:
    case InspectionType.VANSCOY_PANEL_INSPECTION:
    case InspectionType.VANSCOY_AREA_PREOP_CUTTING_CHECK:
    case InspectionType.VANSCOY_SAFETY_CHECK_BEFORE_CUTTING:
    case InspectionType.VANSCOY_SAFETY_CHECK_DURING_CUTTING:
    case InspectionType.CORY_LUNCH_AREA_CHECK:
    case InspectionType.CORY_REFUGE_CHECK:
    case InspectionType.CORY_MONTHLY_PANEL_INSPECTION:
    case InspectionType.AREA_CHECK_LUNCH_TABLE:
    case InspectionType.AREA_CHECK_EXTENSIBLE_DRIVE:
    case InspectionType.AREA_CHECK_MINING_FACE:
    case InspectionType.AREA_CHECK_BREAKTHROUGH_ROOM:
    case InspectionType.AREA_CHECK_REFUGE:
    case InspectionType.VANSCOY_AREA_CUTTING_CHECK:
    case InspectionType.VANSCOY_AREA_PREOP_CHECK:
    case InspectionType.BIT_RACK_CHECK:
      return InspectionType.CUSTOM_AREA_CHECK;
    default:
      console.error('Unsupported Inspection Type', inspectionType);
      return InspectionType.CUSTOM_AREA_CHECK;
  }
};

export const MenuAreaToShowInspectionType = (inspectionType: InspectionType): InspectionTab => {
  const mappedInspectionType = mapToChecksAdminInspectionType(inspectionType);
  if (mappedInspectionType === InspectionType.CUSTOM_EQUIPMENT) return InspectionTab.EQUIPMENT;

  return InspectionTab.AREA;
};

export const InspectionTypeMenuOrder = [
  InspectionType.WORKFACE_AREA_INSPECTION,
  InspectionType.CUSTOM_AREA_CHECK,
  InspectionType.CUTTING_PERMIT,
];
